import { useMemo } from 'react';

import dynamic from 'next/dynamic';

import { Header } from '@components/views/landing/common/Header/Header';
import { CategoryPromotionViewModel } from '@api/index';
import { formatCategoryPromotion } from '@components/views/homepage/formats';
import { useDevice } from '@contexts/device';

import type { CategoryPromotionType } from './CategoryPromotionDesktop';
import { Wrapper } from './styled';
const CategoryPromotionMobile = dynamic(
  () => import('./CategoryPromotionMobile')
);

const CategoryPromotionDesktop = dynamic(
  () => import('./CategoryPromotionDesktop')
);

export interface CategoryCardInfo {
  title: string;
  price: number;
  subText?: string;
  src: string;
  alt?: string;
  link?: string;
}

export type CategoryPromotionProps = CategoryPromotionViewModel & {
  categoryPromotionType: CategoryPromotionType;
};

const CategoryPromotion = ({
  items,
  link = [],
  name: title = '',
  subText: description = '',
  categoryPromotionType,
}: CategoryPromotionProps) => {
  const { isDesktop } = useDevice();
  const landingData = useMemo(() => {
    return items?.length && isDesktop !== undefined
      ? formatCategoryPromotion(items, isDesktop)
      : [];
  }, [items, isDesktop]);
  const hasShowAllPromotionsAction =
    categoryPromotionType !== 'userHotelRecommandations';

  return (
    <Wrapper>
      <Header
        link={link?.[0]?.href}
        linkText={link?.[0]?.name}
        title={title}
        description={description}
        hasShowAllPromotionsAction={hasShowAllPromotionsAction}
      />
      {!isDesktop ? (
        <CategoryPromotionMobile
          data={landingData}
          link={link?.[0]?.href}
          linkText={link?.[0]?.name}
          hasShowAllPromotionsAction={hasShowAllPromotionsAction}
        />
      ) : (
        <CategoryPromotionDesktop
          type={categoryPromotionType}
          data={landingData}
        />
      )}
    </Wrapper>
  );
};

export default CategoryPromotion;
